import React from "react";
import ReactDOM from "react-dom/client";
import { FxmsLogin } from "./fxms/login/FxmsLogin";

// subkjh :: 이렇게 해야 생성될 때 내용을 처리한다.
// const App = React.lazy(() => import('./App_subkjh'));
// subkjh : 아래 내용으로 하면 바로 생성된다.

import FxBaseService from "./fxms/components/FxBaseService";
import { FxmsData } from "./fxms/datas/FxData";
import jwt_decode from "jwt-decode";
import * as authAction from "./fxms/jwt/auth-action";
import { store } from "./modules/store";
import { Provider } from "react-redux";
import "./index.css";
import "./css/vup.css";
import "./css/FxIconValuePanel.css";
// import "./css/h2.css";

/*
// 로그인되어 있는지 확인한다.
let token = localStorage.getItem("token");
let userNo = localStorage.getItem("FXMS-USERNO");
const time = localStorage.getItem("FXMS-TIME");

if (time) {
  if (parseFloat(time) + 3000 < new Date().getTime()) {
    userNo = null;
  }
} */

let token = null;
let userNo = null;

const tokenData = authAction.retrieveStoredToken();
if (tokenData != null && tokenData.token != null) {
  token = tokenData.token;
  userNo = jwt_decode(token).userNo;
}
FxmsData.setMngDiv(window.location.pathname);
console.log("*** FXMS ***", token, userNo, window);

// 로그인 되어 있으면 화면 구성정보를 가지고 온 다음 Application을 실행한다.
if (token && userNo) {
  FxmsData.getFxmsConfig(userNo, token)
    .then(function (res) {
      console.log("*** FXMS ***", res);

      // 브라우저 타이틀변경
      const title = FxmsData.getVarValue(
        "ui-title",
        "Thingspire Industrial Service Platform"
      );
      document.title = title;

      window.addEventListener("beforeunload", function (e) {
        localStorage.setItem("FXMS-TIME", new Date().getTime());

        // onunload, beforeunload
        // FxmsData.removeLocalStorage();
        // e.preventDefault();
        // e.returnValue = ''; 
      });

      const root = ReactDOM.createRoot(document.getElementById("root"));
      root.render(<Provider store={store}>{FxBaseService()}</Provider>);
    })
    .catch(function (error) {
      // alert("화면 구성 정보를 가져오지 못했습니다.\n다시 시도하기 바랍니다.");
      localStorage.removeItem("token");
      document.location.href = "/";
    });
}

// 로그인 정보가 없으면 로그인 창을 보여준다.
else {
  localStorage.removeItem("basUiGrpNo");
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<FxmsLogin root={root} />);
}
